import React from "react";
import PropTpyes from "prop-types";


export class Checkbox extends React.Component {
  static propTypes = {
    onChange: PropTpyes.func.isRequired,
    checked: PropTpyes.bool.isRequired,
    prof: PropTpyes.string.isRequired,
    device: PropTpyes.string.isRequired
  };

  render() {
    return (
      <label className="switch">
        <input
          type="checkbox"
          checked={this.props.checked}
          onChange={() =>
            this.props.onChange(
              !this.props.checked,
              parseInt(this.props.device),
              parseInt(this.props.prof)
            )
          }
        />
        <div className="slider" />
      </label>
    );
  }
}
